import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { LinkedIn, GitHub } from "@mui/icons-material";
import { Box } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0A0A0A",
        color: "#ffffff",

        p: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="#ffffff" gutterBottom>
              About
            </Typography>
            <Typography variant="body2" color="#ffffff">
              This website is my personal project, developed for learning
              purposes.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="#ffffff" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2" color="#ffffff">
              London, UK
            </Typography>
            <Typography variant="body2" color="#ffffff">
              Email: kronverk01@gmail.com
            </Typography>
            <Typography variant="body2" color="#ffffff">
              Phone: better to send an email
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="#ffffff" gutterBottom>
              Follow
            </Typography>
            <Link
              href="https://github.com/OlenaReukova"
              color="inherit"
              sx={{ pl: 1, pr: 1 }}
            >
              <GitHub />
            </Link>
            <Link
              href="https://www.linkedin.com/in/olenareukova"
              color="inherit"
            >
              <LinkedIn />
            </Link>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography variant="body2" color="#ffffff" align="center">
            {"© "}
            <Link
              color="inherit"
              href="https://www.linkedin.com/in/olenareukova"
            >
              Created by Olena Reukova
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
export default Footer;
